import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {AssistanceApplicationStatus} from '../../../../../../../../shared/enums/assistance-application-status';
import {AssistanceApplication, User} from '../../../../../../../../services/api.client';
import {PromptComponent} from '../../../../../../../shared/dialogs/PromptComponent';
import {environment} from '../../../../../../../../../environments/environment';

@Component({
    selector: 'app-assistance-application-agency-audit',
    templateUrl: './assistance-application-agency-audit.component.html',
    styleUrls: ['./assistance-application-agency-audit.component.scss'],
    standalone: false
})
export class AssistanceApplicationAgencyAuditComponent {

    protected readonly AssistanceApplicationStatus = AssistanceApplicationStatus;

    @Input() assistanceApplication: AssistanceApplication;
    @Input() assistanceApplicationId: string;
    @Input() user: User;

    @Output() submitReadyForReview = new EventEmitter<void>();

    @ViewChild('agencyInfoRequestModal') agencyInfoRequestModal: PromptComponent;
    @ViewChild('passAgencyReviewModal') passAgencyReviewModal: PromptComponent;
    @ViewChild('infoRequestModal') infoRequestModal: PromptComponent;
    @ViewChild('passReviewModal') passReviewModal: PromptComponent;
    @ViewChild('denyReviewModal') denyReviewModal: PromptComponent;

    get canReview(): boolean {
        return this.user?.canReviewApplications &&
            (this.assistanceApplication?.status === AssistanceApplicationStatus.UnderReview
                || this.assistanceApplication?.status === AssistanceApplicationStatus.UnderAgencyReview);
    }

    get canSubmitReadyForReview(): boolean {
        return (this.assistanceApplication?.status === AssistanceApplicationStatus.InfoNeeded
                || this.assistanceApplication?.status === AssistanceApplicationStatus.AgencyInfoNeeded)
            && !!this.assistanceApplication?.currentInformationRequest;
    }

    get isUnitedWayAgencyUser(): boolean {
        const unitedWayAgencyId = environment.appConfig.UWSTLAgencyId;
        return this.user?.agency?.id === unitedWayAgencyId;
    }

    get isAgencyAssignedStep(): boolean {
        return this.assistanceApplication?.status === AssistanceApplicationStatus.UnderAgencyReview ||
            this.assistanceApplication?.status === AssistanceApplicationStatus.AgencyInfoNeeded;
    }

    constructor() {}

    getAgencyApplicationStatusText(): string {
        switch (this.assistanceApplication?.status) {
            case AssistanceApplicationStatus.Approved:
                return 'UW Approved';
            case AssistanceApplicationStatus.UnderReview:
                return 'Under UW Review';
            case AssistanceApplicationStatus.ReviewPassed:
                return 'Passed UW Review';
            case AssistanceApplicationStatus.Denied:
                return 'Denied';
            case AssistanceApplicationStatus.InfoNeeded:
                return 'UW Information Needed';
            case AssistanceApplicationStatus.Submitted:
                return 'Submitted';
            case AssistanceApplicationStatus.UnderAgencyReview:
                return 'Under Agency Review';
            case AssistanceApplicationStatus.AgencyInfoNeeded:
                return 'Agency Information Needed';
            default:
                return '';
        }
    }

    getApplicationIconClasses(): string {
        switch (this.assistanceApplication?.status) {
            case AssistanceApplicationStatus.Approved:
                return 'fa fa-check-circle-o status-icon-green';
            case AssistanceApplicationStatus.UnderReview:
                return 'fa fa-hourglass-half status-icon-blue';
            case AssistanceApplicationStatus.ReviewPassed:
                return 'fa fa-check-circle-o status-icon-green';
            case AssistanceApplicationStatus.Denied:
                return 'fa fa-exclamation-circle status-icon-red';
            case AssistanceApplicationStatus.InfoNeeded:
                return 'fa fa-info-circle status-icon-amber';
            case AssistanceApplicationStatus.Submitted:
                return 'fa fa-paper-plane-o';
            case AssistanceApplicationStatus.UnderAgencyReview:
                return 'fa fa-hourglass-half status-icon-blue';
            case AssistanceApplicationStatus.AgencyInfoNeeded:
                return 'fa fa-info-circle status-icon-amber';
            default:
                return '';
        }
    }

    showAgencyInfoRequestModal(): void {
        this.agencyInfoRequestModal?.open();
    }

    onClickCancelAgencyInfoRequest(): void {
        this.agencyInfoRequestModal?.close();
    }

    showPassAgencyReviewModal(): void {
        this.passAgencyReviewModal.open();
    }

    onClickCancelPassAgencyReview(): void {
        this.passAgencyReviewModal.close();
    }

    public async setReadyForReview(): Promise<void> {
        this.submitReadyForReview.emit();
    }

    showInfoRequestModal(): void {
        this.infoRequestModal?.open();
    }

    onClickCancelInfoRequest(): void {
        this.infoRequestModal?.close();
    }

    showPassReviewModal(): void {
        this.passReviewModal.open();
    }

    onClickCancelPassReview(): void {
        this.passReviewModal.close();
    }

    showDenyReviewModal(): void {
        this.denyReviewModal.open();
    }

    onClickCancelDenyReview(): void {
        this.denyReviewModal.close();
    }
}
